import React, { useState, useEffect, useCallback } from 'react'
import DataTable from 'react-data-table-component'
import { getStudentIdData, addData, deleteIdData } from '../../lib/studentcollegelist'
import { getAllData } from '../../lib/collegerank'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { getCollegeListForGoalsColumns } from '../../Data/GoalQuestions/CollegeListForGoalsData'
import { useParams } from 'react-router-dom'

export const CollegeListForGoals = ({ studentId: propStudentId }) => {
	const { studentId: paramStudentId } = useParams()
	const { user } = useAuth()
	const effectiveStudentId = propStudentId || paramStudentId || user?.id

	const [collegelist, setCollegeList] = useState([])
	const [studentCollegeList, setStudentCollegeList] = useState([])
	const [filterText, setFilterText] = useState('')
	const [loading, setLoading] = useState(true)

	function getStudentData(colid) {
		if (studentCollegeList.length > 0) {
			const result = studentCollegeList.filter((item) => item.collegeId === colid)
			return result.length > 0 ? result[0].id : 0
		}
		return 0
	}

	function getStudentCollege(colid) {
		if (studentCollegeList.length > 0) {
			const result = studentCollegeList.filter((item) => item.collegeId === colid)
			return result.length > 0 ? result[0].isCheck : false
		}
		return false
	}

	async function UpdateisCheck(Id, isCheck, collegeId) {
		try {
			if (Id === 0) {
				await addData({
					isCheck: !isCheck,
					studentId: effectiveStudentId,
					collegeId: collegeId
				})
			} else {
				await deleteIdData(Id)
			}
			await GetData()
		} catch (error) {
			console.error('Error updating college check status:', error)
		}
	}

	function ChangeStatus(Id, isCheck, collegeId) {
		UpdateisCheck(Id, isCheck, collegeId)
	}

	const GetData = useCallback(async () => {
		try {
			setLoading(true)
			const colleges = await getAllData()
			setCollegeList(colleges)

			const studentdata = await getStudentIdData(effectiveStudentId)
			setStudentCollegeList(studentdata)
		} catch (error) {
			console.error('Error fetching college data:', error)
		} finally {
			setLoading(false)
		}
	}, [effectiveStudentId])

	useEffect(() => {
		if (effectiveStudentId) {
			GetData()
		}
	}, [effectiveStudentId, GetData])

	const filteredColleges = collegelist.filter(
		(item) => item.collegename?.toLowerCase().includes(filterText.toLowerCase()) || item.id?.toString().includes(filterText)
	)

	const columns = getCollegeListForGoalsColumns(getStudentData, getStudentCollege, ChangeStatus)

	const customStyles = {
		headCells: {
			style: {
				fontSize: '14px',
				fontWeight: 'bold',
				textTransform: 'uppercase',
				color: '#000'
			}
		},
		rows: {
			style: {
				minHeight: '50px',
				fontSize: '14px',
				color: '#000'
			}
		},
		cells: {
			style: {
				paddingTop: '12px',
				paddingBottom: '12px',
				fontSize: '14px',
				color: '#000'
			}
		}
	}

	return (
		<div className="col-12">
			<div className="card shadow-sm mb-4" style={{ borderRadius: '8px' }}>
				<div className="card-header border-bottom d-flex justify-content-between align-items-center">
					<div className="d-flex align-items-center">
						<button
							type="button"
							className="btn btn-link p-0 me-2"
							data-bs-toggle="collapse"
							data-bs-target="#collapseCollegeList"
							aria-expanded="false"
							aria-controls="collapseCollegeList"
						>
							<i className="fa fa-chevron-down"></i>
						</button>
						<h5 className="mb-0 d-inline-block">College List</h5>
					</div>
				</div>
				<div className="collapse" id="collapseCollegeList">
					<div className="card-body">
						<div className="d-flex justify-content-between align-items-center mb-3">
							<h6 className="mb-0">Select colleges you're interested in</h6>
							<input
								type="text"
								placeholder="Search colleges..."
								className="form-control"
								style={{ maxWidth: '300px' }}
								value={filterText}
								onChange={(e) => setFilterText(e.target.value)}
							/>
						</div>

						{loading ? (
							<div className="text-center p-4">
								<div className="spinner-border" role="status">
									<span className="visually-hidden">Loading...</span>
								</div>
								<p className="mt-2">Loading colleges...</p>
							</div>
						) : (
							<DataTable
								columns={columns}
								data={filteredColleges}
								pagination
								paginationPerPage={25}
								paginationRowsPerPageOptions={[10, 25, 50, 100]}
								highlightOnHover
								striped
								responsive
								dense
								persistTableHead
								customStyles={customStyles}
								noDataComponent={
									<div className="text-center p-4">
										<p className="text-muted">No colleges found</p>
									</div>
								}
							/>
						)}
					</div>
				</div>
			</div>
		</div>
	)
}
